import { createSelector } from 'reselect'

import { IApplicationState } from '@Site/rootReducer'

import {
  ISpeakerVoice,
  TSpeakerVoiceUsedLanguages,
  TSpeakerVoiceLanguages,
  TSpeakerVoiceLanguagesNamesAndCountries,
} from './types'

export const getSpeakerVoices = (state: IApplicationState): ISpeakerVoice[] => state.speakerVoices.speakerVoices
export const getLanguages = (state: IApplicationState): TSpeakerVoiceLanguages => state.speakerVoices.languages
export const getHasLoadedInitially = (state: IApplicationState): boolean => state.speakerVoices.hasLoadedInitially
export const getLoading = (state: IApplicationState): boolean => state.speakerVoices.loading
export const getIsGeneratingDesignSample = (state: IApplicationState): boolean => state.speakerVoices.isGeneratingDesignSample
export const getGeneratedDesignSampleUrl = (state: IApplicationState): string | undefined => state.speakerVoices.generatedDesignSampleUrl
export const getGeneratedDesignSampleError = (state: IApplicationState): string | null | undefined => state.speakerVoices.generatedDesignSampleError
export const getCurrentPage = (state: IApplicationState): number => state.speakerVoices.page.currentPage
export const getTotalPages = (state: IApplicationState): number => state.speakerVoices.page.totalPages
export const getTotalCount = (state: IApplicationState): number => state.speakerVoices.page.totalCount
export const getShouldCheckAutoFill = (state: IApplicationState): boolean => state.speakerVoices.page.shouldCheckAutoFill
export const getSelectedIds = (state: IApplicationState): string[] => state.speakerVoices.selectedIds
export const getSearchTerm = (state: IApplicationState): string | undefined => state.speakerVoices.page.searchTerm
export const getOpenedSpeakerVoiceId = (state: IApplicationState): string | undefined => state.speakerVoices.openedSpeakerVoiceId
export const getIsNewSpeakerVoice = (state: IApplicationState): boolean => state.speakerVoices.isNewSpeakerVoice
export const getUsedLanguages = (state: IApplicationState): TSpeakerVoiceUsedLanguages => state.speakerVoices.usedLanguages
export const getSelectedLanguagesNames = (state: IApplicationState): string[] => state.speakerVoices.selectedLanguagesNames

export const getLanguagesNames = createSelector(
  [getLanguages],
  (languages) => {
    const languagesNamesSet = new Set<string>()

    Object.values(languages).forEach(languageData => {
      languagesNamesSet.add(languageData.name)
    })

    return Array.from(languagesNamesSet)
  }
)

export const getLanguagesNamesAndCountries = createSelector(
  [getLanguages],
  (languages) => {
    const languagesNamesAndCountries: TSpeakerVoiceLanguagesNamesAndCountries = {}

    Object.values(languages).forEach(languageData => {
      languagesNamesAndCountries[languageData.name] ||= []

      if (languageData.country && !languagesNamesAndCountries[languageData.name].includes(languageData.country)) {
        languagesNamesAndCountries[languageData.name].push(languageData.country)
      }
    })

    return languagesNamesAndCountries
  }
)

export const getOpenedSpeakerVoice = createSelector(
  [getSpeakerVoices, getOpenedSpeakerVoiceId],
  (speakerVoices, openedSpeakerVoiceId) => speakerVoices.find(speakerVoice => speakerVoice.id === openedSpeakerVoiceId)
)
